/*
 * This is the container for the detailed view or cropper component for
 * the editor.
 */
import React from 'react'
import Detailed from './detailed'
import AppDispatcher from '../../../dispatcher/app-dispatcher'
import ProductStore from '../../../stores/product-store'
import createReactClass from 'create-react-class'


var DetailedContainer = createReactClass({
	getDefaultProps: function() {
		return {
			item: {}
		};
	},

	render: function() {
		var productOptions = ProductStore.getProductById(this.props.item.productId).options;
		return (
			<Detailed item={this.props.item} saveCallback={this.props.saveCallback} productOptions={productOptions}/>
		);
	}
});

export default DetailedContainer;
